// extracted by mini-css-extract-plugin
module.exports = {"courseHeader":"CourseHeader_courseHeader__o-OAe","button":"CourseHeader_button__16_mh","publishButton":"CourseHeader_publishButton__1l1gZ"};